<template>
<div>
    <Tabs :value="tabVal">
        <!-- 型式试验流程列表 -->
        <TabPane :label="$t('typeTestProcessSearch.t1')" name="typeTestProcessSearch">
            <m-assembly-table ref='pageForm'
                            :formData='formData'
                            :columns='columns'
                            :data='tableData'
                            :tableButtons='tableButtons'
                            :loading='loading'
                            :currentPage='settings.currentPage'
                            :pageSize='settings.pageSize'
                            :total='settings.total'
                            :settings='settings'
                            @onSubmit='onSubmit'
                            @onPageSizeChange='onPageSizeChange'
                            @onCurrentPageChange='onPageChange'
                            thDrag
            >
            </m-assembly-table>
        </TabPane>
        <!-- 型式试验报表查询 -->
        <TabPane :label="$t('typeTestProcessSearch.t16')" name="typeTestReportSearch">
            <type-test-report-search></type-test-report-search>
        </TabPane>
    </Tabs>
    
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import typeTestReportSearch from './typeTestReportSearch';
export default {
    name: 'typeTestProcessSearch',
    components: { mAssemblyTable, typeTestReportSearch },
    data() {
        return {
            tabVal: 'typeTestProcessSearch',
            mdmCode: '',
            condition: {},
            loading: false,
            dict: {
                reportStatusList: [
                    // {label: '待检验', value: 'WAITING'},
                    // {label: '已检验', value: 'EXAMINED'},
                    // {label: '废弃', value: 'ABANDON'},
                ], // 状态 待检验WAITING /已检验EXAMINED/废弃ABANDON
                testTypeList: [
                    {label: this.$t('typeTestProcessSearch.t2'), value: 'TYPETEST'}, // 型式试验
                    {label: this.$t('typeTestProcessSearch.t3'), value: 'DPA'}, // DPA分解
                ], // QMS结果过来的testType,testType=型式试验，DPA=DPA分解
            },
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
            },
            formData: {
                row: 2,
                items: [
                    {
                        title: this.$t('typeTestProcessSearch.t4'), // 事业部
                        placeholder: this.$t('typeTestProcessSearch.t5'), // 请选择事业部
                        value: '',
                        field: 'divId',
                        clearable: true,
                        filterable: true,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {}
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('typeTestProcessSearch.t2'), // 事业部不能为空
                            }
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t6'), // 状态
                        placeholder: '', // 请选择状态
                        value: '',
                        field: 'reportStatus',
                        clearable: true,
                        filterable: true,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {}
                        },
                        options: {
                            multiple: false,
                            values: () => this.dict.reportStatusList
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: false,
                                message: ''
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'examinedNo',
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        style: 'width:100%',
                        type: 'text',
                        title: this.$t('typeTestProcessSearch.t7') // 单据号
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t8'), // 试验类型
                        placeholder: this.$t('typeTestProcessSearch.t9'), // 请选择试验类型
                        value: '',
                        field: 'testType',
                        clearable: true,
                        filterable: true,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        methods: {
                            change: () => {}
                        },
                        options: {
                            multiple: false,
                            values: [
                                {label: this.$t('typeTestProcessSearch.t2'), value: 'TYPETEST'}, // 型式试验
                                {label: this.$t('typeTestProcessSearch.t3'), value: 'DPA'}, // DPA分解
                            ]
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: false,
                                message: ''
                            }
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t10'), // 创建时间
                        isDouble: true,
                        value: moment(new Date()).subtract(6, 'd')._d,
                        field: 'startDate',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: false,
                                message: ''
                            }
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date) {}
                            }
                        },
                        change: (dateObj, time) => {
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t10'), // 创建时间
                        hide: true,
                        value: new Date().getTime(),
                        field: 'endDate',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: false,
                                message: ''
                            },
                            validator: (rule, value, callback, source, options) => {
                                let start = this.getFormDataItemVal(this.formData.items, 'startDate');
                                let end = this.getFormDataItemVal(this.formData.items, 'endDate');
                                if (new Date(start).getTime() > new Date(end).getTime()) {
                                    callback(['结束日期不能小于开始日期']);
                                    return false;
                                }
                                // else if (moment(end).subtract('1', 'M').format('x') > moment(start).format('x')) {
                                //     callback(['日期区间限定为1个月']);
                                //     return false;
                                // }
                                else {
                                    callback([]);
                                }
                            }
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd'
                        }
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        style: 'width:100%',
                        type: 'text',
                        title: this.$t('typeTestProcessSearch.t11'), // 物料编码
                    }
                ],
                buttons: {
                    showSubmit: true,
                    showReset: true,
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            tableButtons: {
                customButtons: [
                    {
                        name: 'btn_export',
                        label: this.$t('commonTw.t1'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        size: 'small',
                        click: () => {
                            if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                return false;
                            }
                            this.exportToExcel();
                        }
                    }
                ]
            },
            columns: {
                showCheckbox: false,
                showButtons: false,
                columns: [
                    {
                        title: this.$t('typeTestProcessSearch.t4'), // 事业部
                        key: 'divName',
                        tooltip: true,
                        minWidth: 180
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t7'), // 单据号
                        key: 'examinedNo',
                        tooltip: true,
                        minWidth: 110,
                        render: (h, params) => {
                            return h('a', {
                                on: {
                                    click: () => {
                                        const { id } = params.row;
                                        this.$router.push({
                                            name: 'typeTestProcessList',
                                            query: {
                                                id
                                            }  
                                        });
                                    }
                                }
                            }, params.row.examinedNo);
                        },
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t6'), // 状态
                        key: 'reportStatus',
                        align: 'center',
                        tooltip: true,
                        minWidth: 100
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t8'), // 试验类型
                        key: 'testType',
                        align: 'center',
                        tooltip: true,
                        minWidth: 100
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t11'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        tooltip: true,
                        minWidth: 130
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t12'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 200,
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                content: params.row.itemDesc,
                                placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.itemDesc);
                        }
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t13'), // 驳回次数
                        key: 'rejectCount',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t14'), // 驳回原因
                        key: 'rejectReason',
                        tooltip: true,
                        minWidth: 100
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t15'), // 创建人
                        key: 'releaseUser',
                        align: 'center',
                        tooltip: true,
                        minWidth: 80
                    },
                    {
                        title: this.$t('typeTestProcessSearch.t10'), // 创建时间
                        key: 'releaseDateStr', //releaseDate/releaseDateStr
                        align: 'center',
                        tooltip: true,
                        minWidth: 130
                    }
                ]
            },
            tableData: []
        };
    },
    computed: {
        queryInfo() {
            let params = {};
            this.formData.items.forEach((item) => {
                params[item.field] = item.value ? (item.type === "datePicker" ? moment(item.value).format('YYYY-MM-DD') : item.value) : "";
            });
            return params;
        },
    },
    methods: {
        /** 当前页改变时触发 */
        onPageChange(currentPage, pageSize, condition) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(currentPage, pageSize, condition) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSubmit(page, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = page;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch() {
            if (!this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                return false;
            }
            let language = this.$i18n.locale.includes('US') ? 'US' : this.$i18n.locale;
            let params = {
                pageNum: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                vendorCode: this.vendorCode,
                ...this.queryInfo,
                language: language,
                isSaveLog: this.isPro() ? 'N' : 'Y', // 生产环境传N，测试环境传Y
                mdmCode: this.mdmCode
            };
            params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD 00:00:00') : '';
            params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD 23:59:59') : '';
            this.loading = true;
            this.tableButtons.customButtons[0].loading = true;
            this.tableData = [];
            axios.post('/gscint/gscTypeTestInfo/queryPageList', params)
            .then(res => {
                console.log('res::', res);
                this.loading = false;
                this.tableButtons.customButtons[0].loading = false;
                if (res.data.success === true) {
                    this.tableData = res.data.data.list;
                    this.settings.total = res.data.data.total;
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: res.data.msg
                    });
                }
            })
            .catch(() => {
                this.loading = false;
                this.tableButtons.customButtons[0].loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 导出Excel */
        exportToExcel() {
            this.tableButtons.customButtons[0].loading = true;
            var a = document.createElement('a');
            let language = this.$i18n.locale == 'zh-CN' ? 'zh-CN' : 'US';
            let params = {
                vendorCode: this.vendorCode,
                ...this.queryInfo,
                language: language,
                isSaveLog: this.isPro() ? 'N' : 'Y', // 生产环境传N，测试环境传Y
                mdmCode: this.mdmCode
            };
            params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD 00:00:00') : '';
            params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD 23:59:59') : '';
            axios.get(`/gscint/gscTypeTestInfo/exportExcel`, {
                    params: params,
                    responseType: 'blob'
            })
            .then((res) => {
                this.tableButtons.customButtons[0].loading = false;
                this.downloadFile(res.data, `${this.$t('typeTestProcessSearch.t1')}.xlsx`);
            })
            .catch(() => {
                this.tableButtons.customButtons[0].loading = false;
                this.showErrorTips();
            });
        },
        // 获取快码通用接口
        getDictCode (code, callback = undefined) {
            axios.get(`/gscint/sys/sysParam/queryDictionaryData?dictCode=${code}&isValid=Y`)
            .then((res) => {
                let data = res.data.data;
                if (data) {
                    this[`${code}`] = data;
                    if (callback) {
                        callback(data);
                    }
                }
            });
        },
        /** 获取事业部 */
        getBuName () {
            // axios.get('/gscapp/lov/getBULovNew?UP=Y&SITE=Y&ASL=N&labelName=buName&valueName=buId')
            axios.get('/gscint/vendor/getOverSeaBuList', {
                params: {
                    SITE: 'Y',
                    ASL: 'N'
                }
            })
            .then((res) => {
                const data = res.data.data.datas;
                data.forEach((item) => {
                    item.label = item.buName;
                    item.value = item.qmsId;
                });
                this.getFormDataItemObj(this.formData.items, 'divId').options.values = data;
            });
        },
        queryVendorAndMdm() {
            axios.post('/gscint/vendor/queryVendorAndMdm', {
                vendorCode: this.vendorCode
            }).then((res) => {
                this.mdmCode = res.data.data.datas.mdmCode;
            });
        },
    },
    mounted() {
        // this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
        this.queryVendorAndMdm();
        this.getBuName();
        // 状态
        this.getDictCode('INT_SY_STATUS', (data) => {
            data.forEach(item => {
                if(this.$i18n.locale != 'zh-CN') {
                    item.label = item.valueEn || item.label
                }
            })
            this.dict.reportStatusList = data;
            this.getFormDataItemObj(this.formData.items, 'reportStatus').options.values = data;
        });
        // 试验类型
        this.getFormDataItemObj(this.formData.items, 'testType').options.values = this.dict.testTypeList;
        // 默认reportStatus=WAITING
        this.getFormDataItemObj(this.formData.items, 'reportStatus').value ='WAITING';
    }
};
</script>

<style lang='less' scoped>
</style>